import { GRID_DIRECTION } from "../../const/grid-directions.const";

// Default values for grid cell
export const GRID_CELL_CONFIG = {
    fillStyle: "#FFFFFF",
    strokeStyle: "#F0F0F0",
    lineWidth: 1
};
// Default values for grid cell content container
export const CONTENT_CONTAINER_CONFIG = {
    contentContainerWidthPercentage: 60,
    contentContainerHeightPercentage: 60,
    contentContainerRadius: 0
};
// Default values for grid cell content
export const CONTENT_CONFIG = {
    contentContainerWidthPercentage: 46,
    contentContainerHeightPercentage: 46,
    contentContainerRadius: 0
};
// grid content container selected style
export const GRID_CONTENT_CONTAINER_SELECTED_STYLE = {
    fillStyle: "#F5F8FF",
    strokeStyle: "#7495E3"
};
// grid content  selected style
export const GRID_CONTENT_CONTAINER_STYLE = {
    fillStyle: "#FFFFFF",
    strokeStyle: "#FAFAFA"
};
// default cell style
export const CELL_STYLE = {
    fillStyle: "#FFFFFF",
    strokeStyle: "#F0F0F0"
};
// cell hover styling
export const CELL_HOVER_STYLE = {
    fillStyle: "#F4F7FE",
    strokeStyle: "#5784CE"
};
// cell invalid hover styling
export const CELL_HOVER_INVALID_STYLE = {
    fillStyle: "#d13050",
    strokeStyle: "#FF0000"
};
// temporary cell styling
export const TEMPORARY_CELL = {
    fillStyle: "#E2ECF8",
    strokeStyle: "#E8F2FB"
};
// endpoint radius
export const ENDPOINT_RADIUS = 4.5;
// draggable endpoint radius
export const DRAGGABLE_ARROW_ENDPOINT_RADIUS = 9.5;
// possible endpoint directions
export const ENDPOINT_DIRECTIONS_OBJECT = {
    TOP: GRID_DIRECTION.TOP,
    LEFT: GRID_DIRECTION.LEFT,
    RIGHT: GRID_DIRECTION.RIGHT,
    BOTTOM: GRID_DIRECTION.BOTTOM
};
// active endpoint styling
export const ACTIVE_ENDPOINT = {
    fillStyleFirst: "#4089EE",
    fillStyleSecond: "#FFFFFF"
};
// label dragging fillStyle
export const LABEL_DRAGPOINT = {
    fillStyleFirst: "#F2BD46"
};
// inactive endpoint styling
export const INACTIVE_ENDPOINT = {
    fillStyleFirst: "#808080",
    fillStyleSecond: "#FFFFFF"
};
// error connecting line styling
export const ERROR_CONNECTING_LINES = {
    strokeStyle: "#cc0000",
    fillStyle: "#cc0000",
    lineWidth: 1
};
// error endpoint styling
export const ERROR_ENDPOINT = {
    fillStyleFirst: "#cc0000",
    fillStyleSecond: "#FFFFFF"
};
// disabled endpoint styling
export const DISABLED_ENDPOINT = {
    fillStyleFirst: "#D3D3D3",
    fillStyleSecond: "#FFFFFF"
};
// active connecting line styling
export const ACTIVE_CONNECTING_LINES = {
    strokeStyle: "#4285F4",
    fillStyle: "#4285F4",
    lineWidth: 1
};
// inactive connecting line styling
export const INACTIVE_CONNECTING_LINES = {
    strokeStyle: "#808080",
    fillStyle: "#808080",
    lineWidth: 1
};
// disabled connecting line styling
export const DISABLED_CONNECTING_LINES = {
    strokeStyle: "#D3D3D3",
    fillStyle: "#D3D3D3",
    lineWidth: 1
};
// clickable elemetns inside a cell
export const GRID_CELL_CLICKABLE_ELEMENTS = {
    DRAGGABLE_ENDPOINT: "DRAGGABLE_ENDPOINT",
    CELL_LABEL: "CELL_LABEL",
    CONTENT: "CONTENT"
};
// label config
export const LABEL_PROPERTIES = {
    fontLabel: "9",
    fontLabelEditMode: "12",
    paddingLabelY: 5,
    paddingLabelTopBottom: 3,
    backgroundBorderRadius: 9,
    lineWidthBackground: 1,
    backgroundStrokeTask: "#F2F2F2",
    backgroundFillTask: "#ffffff",
    backgroundStrokeConnector: "#E5E5E5",
    backgroundFillConnector: "#F2F2F2",
    dragPointFillConnector: "#656565",
    dragPointSelectedStrokeTask: "#4285F4",
    taskDragPointColor: "#F2BD46",
    disabledColorLabel: "#D3D3D3",
    paddingLabelX: 4,
    dragPointLabelRadius: 4
};
// default cell layout
export function DEFAULT_CELL_LAYOUT() {
    return {
        x: null,
        y: null,
        width: null,
        height: null,
        radius: null,
        styles: { ...GRID_CELL_CONFIG }
    };
}
// default cell state
export function DEFAULT_CELL_STATE() {
    return {
        selected: false, // indicates the selected status of the cell
        dragHover: false, // indicates if there is a drag event happening over this cell
        temporary: false, // indicats if is a temporary cell
        active: false, //  indicates if the cell is active
        disabled: false, //  indicates if the cell is disabled
        hover: false, // indicates if the cell is being hovered with the mouse
        void: false, // indicates if the cell is covered by a cell independent cell
        drawed: false, // indicates if the cell is drawed
        draggingConnection: false, // indicates if a connector is currently being dragged from this cell
        connectingLineHover: false, // indicates if a connecting line is currently being hovered over the cell
        connectorErrorState: false, // indicates if a connector does not have a label,
        pluginIndexAscTracerOrder: null // plugin index - for appTracer - flow plugin order
    };
}
// default cell content
export function DEFAULT_CELL_CONTENT() {
    return {
        instance: {
            content: null,
            container: null,
            label: null,
            labelPosition: null,
            endpoints: [],
            outGoingPaths: [],
            inGoingPaths: [],
            draggableEndpoint: null

        },
        factory: null,
        config: {
            container: CONTENT_CONTAINER_CONFIG,
            content: CONTENT_CONFIG,
            label: null,
            propertiesLabel: LABEL_PROPERTIES
        }
    };
}
